import { Component } from '@angular/core';
import { CustomizedComponent } from './customized-section/customized-section.component';
import { LeadershipSectionComponent } from './leadership-section/leadership-section.component';
import { CollaborationComponent } from './collaboration-section/collaboration-section.component';
import { OnTargetComponent } from './on-target-section/on-target-section.component';
import { TeamMembersSectionComponent } from './team-members-section/team-members-section.component';

@Component({
    selector: 'about-us',
    standalone: true,
    imports: [CustomizedComponent, LeadershipSectionComponent, CollaborationComponent, OnTargetComponent, TeamMembersSectionComponent],
    templateUrl: './about-us.component.html',
    styleUrl: './about-us.component.less',
})
export class AboutUsComponent {}
